export var ENTITY = "payment-request";
export var REDUCER_KEY = "PAYMENT_REQUESTS_V2";
export var BASE_PATH_ENTITY = "payment-requests";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
